import { Typography } from '../Typography/Typography';
import React, { FunctionComponent, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { CollapseButton } from '../CollapseButton/CollapseButton';

const ExpandableText: FunctionComponent<{
  shortText: string | React.ReactNode;
  longText: string | React.ReactNode;
  textClassName?: string;
  className?: string;
}> = ({ shortText, longText, textClassName, className }) => {
  const [t] = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const text = useMemo(
    () => (expanded ? longText : shortText),
    [expanded, longText, shortText]
  );
  const handleExpand = () => setExpanded(prevValue => !prevValue);
  const buttonLabel = t(expanded ? "collapse" : "expand");
  const testId = expanded ? "collapse-button" : "expand-button";

  return (
    <>
      <Typography  textColor="greys.60" variant="body2" className={textClassName}>{text}</Typography>
      <CollapseButton className={className}
        testId={testId}
        onClick={handleExpand}
        expanded={expanded}>
        {buttonLabel}
      </CollapseButton>
    </>
  );
};

export { ExpandableText };
